export default [
  {
    name: '整改报告',
    path: 'rectificationReportList',
    component: resolve => {
      require(['@/views/rectificationReport/index'], resolve)
    }
  },
  {
    name: '整改报告编辑',
    path: 'rectificationReportForm/:reformReportCode',
    component: resolve => {
      require(['@/views/rectificationReport/form'], resolve)
    }
  },
  {
    name: '整改报告详情',
    path: 'rectificationReportDetail/:reformReportCode',
    component: resolve => {
      require(['@/views/rectificationReport/detail'], resolve)
    }
  }
]
